<script setup lang="ts">
import {onErrorCaptured, provide, readonly, ref} from 'vue';
import {phraseContextKey} from './keys';
import {type AppContext, appContextKey, useContext} from "@hantera/portal-app";


const props = defineProps<{
  appContext: AppContext
  component: any
}>();

provide(phraseContextKey, 'apps.' + props.appContext.appId);
provide(appContextKey, readonly<AppContext>(props.appContext))

const context = useContext()

const error = ref<{
  component: string
  message: Error
  info: string
}>();

onErrorCaptured((err, instance, info) => {
  error.value = {
    component: instance?.$.type.__name ?? 'unknown',
    message: err,
    info
  };
  console.error(err)
  
  return false;
})
</script>

<template>
  <div v-if="error" class="app-view-error">
    <h2>Error in '{{error.component}}' from app '{{appContext.appId}}'</h2>
    
    <p>
      {{ error.message }}
    </p>
    
    <p>{{error.info}}</p>
    
  </div>
  <Suspense v-else>
    <component :is="component" />
  </Suspense>
</template>

<style scoped>
.app-view-error {
  background-color: var(--color-error-100);
  border: 1px solid var(--color-error-25);
  padding: 5px;
}

.app-view-error h2 {
  font-size: 16px;
  font-weight: bold;
  margin: 5px 0;
}

.app-view-error p {
  margin: 5px 0;
}
</style>